import { render, staticRenderFns } from "./WorkflowPacketBuilder.vue?vue&type=template&id=22e86825&scoped=true&"
import script from "./WorkflowPacketBuilder.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPacketBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowPacketBuilder.vue?vue&type=style&index=0&id=22e86825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e86825",
  null
  
)

export default component.exports